module.exports = __webpack_public_path__ + "img/img1.544989c8.png";